import React from "react"
import { RichText } from "../RichText/RichText"
import * as styles from "./text-block.module.scss"
import TableComponent from "../TableComponent/TableComponent"
const TextBlock = ({
    data,
    wideDescription,
    faqComponent,
    alignment,
    table,
}: {
    data
    wideDescription
    faqComponent
    alignment
    table?: any
}) => {
   

    const description = data
    const getAlignment = () => {
        const align = alignment.toLowerCase()

        switch (align) {
            case "left":
                return styles.left

            case "center":
                return styles.center

            default:
                break
        }
    }
    return (
        <div
            className={`${wideDescription ? styles.containerWidthWide : styles.containerWidth
                } ${alignment ? getAlignment() : ""}`}
        >
            {description && (
                <RichText content={description} faqComponent={faqComponent} />
            )}
            {table && <TableComponent noticeData={table} />}
            {table && table.afterTableRichText && (
                <RichText
                    content={table.afterTableRichText}
                    faqComponent={faqComponent}
                />
            )}
        </div>
    )
}

export default TextBlock
